const initialState = {
    taskTypes: [],
    isReadingTaskTypes: false,
    isCreating: false,
    isDeleting: false
}

export default initialState;
